import React from "react";
import { SiteHeader } from "../components/layout/SiteHeader";
import { SiteFooter } from "../components/layout/SiteFooter";
import { Container } from "../components/layout/Container";

export function SimulationPage() {
  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden bg-background-dark text-white">
      <SiteHeader />
      <main className="flex-1 pt-28 pb-16">
        <Container>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-8 md:p-12">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Simulation</p>
            <h1 className="mt-4 text-4xl font-black leading-tight md:text-5xl">
              Run what-if simulations before you commit shipments.
            </h1>
            <p className="mt-5 max-w-3xl text-slate-300">
              Test scenarios for route choice, vehicle mix, shipment split, and loading constraints to predict utilization, cost impact,
              and on-time performance before execution.
            </p>

            <div className="mt-8 grid gap-4 md:grid-cols-3">
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Route Simulation</h3>
                <p className="mt-2 text-sm text-slate-300">Compare lane plans by transit time, capacity, and total cost.</p>
              </div>
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Load Pattern Simulation</h3>
                <p className="mt-2 text-sm text-slate-300">Validate loading patterns against operational rules before dispatch.</p>
              </div>
              <div className="rounded-xl border border-white/10 bg-black/20 p-5">
                <h3 className="font-bold text-white">Risk Simulation</h3>
                <p className="mt-2 text-sm text-slate-300">Identify failure points early and prepare contingency options.</p>
              </div>
            </div>
          </section>
        </Container>
      </main>
      <SiteFooter />
    </div>
  );
}
